export default "__VITE_ASSET__CT0YY1sw__";